import { Component, OnInit } from '@angular/core';
import {AuthService} from "../auth.service";

@Component({
  selector: 'app-change-password',
  templateUrl: './change-password.component.html',
  styleUrls: ['./change-password.component.scss']
})
export class ChangePasswordComponent implements OnInit {
newPassword='AL@123456'
  uid='BIYwLTw9wCNj1O5HjDRGjl3Jgpl1'
  constructor(private authService: AuthService) { }


  ngOnInit(): void {
  }
  changePassword() {
    if (!this.uid || !this.newPassword) {
      console.error('UID and new password are required.');
      // Optionally, show an error message to the user
      return;
    }

    this.authService.changePasswordOfAnotherUser(this.uid, this.newPassword)
      .then(response => {
        console.log('Password changed successfully:', response);
        // Handle successful password change (e.g., clear form, show success message)
      })
      .catch(error => {
        console.error('Error changing password:', error);
        // Handle errors from the Cloud Function
      });
  }
}

